module.exports = __webpack_public_path__ + "static/media/ic_exportWhite.fc4f673f.svg";